/* ==========================================================================
   Hairmosa — page liste d'attente U-Part (section hm-upart-waitlist).
   1. Inscription à la liste Klaviyo (API client, comme hm-popup-quiz.js) :
      prénom, e-mail, propriété de profil UPART_WAITLIST = true, provenance.
      Si cette adresse de Klaviyo est injoignable (bloqueur de publicité,
      navigateur ou réseau qui filtre les traceurs), l'inscription repart par
      le second point d'entrée de Klaviyo, sur un autre domaine.
   2. Message de confirmation : affiché UNIQUEMENT quand Klaviyo a accepté
      l'inscription, par l'une ou l'autre voie. Tout autre cas affiche le
      message d'erreur. Il porte les deux questions facultatives ; chaque
      réponse est enregistrée sur le profil au moment du choix
      (UPART_LONGUEUR, UPART_FINITION). Le compteur d'inscrites augmente de
      un pour la visiteuse qui vient de s'inscrire.
   3. Événements de conversion : après une inscription acceptée seulement,
      et une seule fois par adresse et par navigateur. Les échecs sont
      signalés à part (upart_waitlist_error), avec leur cause.
   4. Bulle de chat masquée sur cette page si la section le demande.
   Aucune dépendance, aucune animation. Chargé en « defer ».
   ========================================================================== */
(function () {
  'use strict';
  if (window.__hmUpart) return;
  window.__hmUpart = true;

  var REVISION_KLAVIYO = '2024-10-15';
  var URL_SECOURS = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
  var CLE_INSCRITES = 'hmu_waitlist';
  var CLE_PROVENANCE = 'hmu_provenance';
  var editeur = !!(window.Shopify && window.Shopify.designMode);

  function stockage(type) {
    try { var s = window[type]; s.setItem('__hmu', '1'); s.removeItem('__hmu'); return s; } catch (e) { return null; }
  }
  var local = stockage('localStorage');
  var session = stockage('sessionStorage');

  /* ---------- Bulle de chat (Zipchat) ----------
     Sur mobile elle recouvre le formulaire. L'application pose elle-même un « display »
     en ligne sur son conteneur : une règle CSS ne suffit pas, d'où ce passage par le script.
     Limité à cette page, et seulement si la section le demande. */
  function initMasquageChat() {
    if (editeur || !document.querySelector('[data-hmu-masquer-chat]') || !('MutationObserver' in window)) return;
    var suivi = null;
    function masquer() {
      var hote = document.getElementById('zipchat-shadow-host');
      if (!hote) return;
      if (hote.style.getPropertyValue('display') !== 'none') hote.style.setProperty('display', 'none', 'important');
      if (suivi !== hote) {
        suivi = hote;
        new MutationObserver(masquer).observe(hote, { attributes: true, attributeFilter: ['style'] });
      }
    }
    masquer();
    new MutationObserver(masquer).observe(document.body, { childList: true });
  }

  /* ---------- Provenance (UTM, sinon site référent) ---------- */
  function lireProvenance() {
    var p = {};
    try {
      var q = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        var v = q.get(k);
        if (v) p[k] = v.slice(0, 120);
      });
    } catch (e) {}
    if (!p.utm_source) {
      var enregistre = null;
      try { enregistre = session && JSON.parse(session.getItem(CLE_PROVENANCE) || 'null'); } catch (e) {}
      if (enregistre) return enregistre;
      var ref = '';
      try { ref = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : ''; } catch (e) {}
      if (ref && ref !== window.location.hostname.replace(/^www\./, '')) {
        if (/tiktok/.test(ref)) p.utm_source = 'tiktok';
        else if (/instagram/.test(ref)) p.utm_source = 'instagram';
        else if (/facebook|fb\.com/.test(ref)) p.utm_source = 'facebook';
        else if (/google\./.test(ref)) p.utm_source = 'google';
        else p.utm_source = ref;
        p.utm_medium = 'referral';
      } else {
        p.utm_source = 'direct';
      }
    }
    try { if (session) session.setItem(CLE_PROVENANCE, JSON.stringify(p)); } catch (e) {}
    return p;
  }

  /* Empreinte non réversible de l'adresse : sert seulement à ne pas recompter une même
     inscription sur ce navigateur. L'adresse elle-même n'est jamais stockée localement. */
  function empreinte(texte) {
    var h = 5381;
    for (var i = 0; i < texte.length; i++) h = ((h << 5) + h + texte.charCodeAt(i)) >>> 0;
    return h.toString(36);
  }
  function dejaComptees() {
    try { return (local && JSON.parse(local.getItem(CLE_INSCRITES) || '[]')) || []; } catch (e) { return []; }
  }
  function memoriser(email) {
    var liste = dejaComptees();
    var e = empreinte(email);
    if (liste.indexOf(e) === -1) liste.push(e);
    try { if (local) local.setItem(CLE_INSCRITES, JSON.stringify(liste.slice(-20))); } catch (err) {}
  }

  /* ---------- Suivi ---------- */
  function suivreConversion(provenance) {
    var source = provenance.utm_source || 'direct';
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('upart_waitlist_signup', { source: source, medium: provenance.utm_medium || '', campaign: provenance.utm_campaign || '' });
      }
    } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { lead_source: 'upart_waitlist', event_category: 'U-Part', event_label: source }); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'U-Part Waitlist', content_category: source }); } catch (e) {}
    try { if (window.ttq && typeof window.ttq.track === 'function') window.ttq.track('SubmitForm', { content_name: 'U-Part Waitlist' }); } catch (e) {}
  }
  /* Échec d'inscription : remonté avec sa cause, pour pouvoir comprendre ce qui bloque. */
  function suivreErreur(cause) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('upart_waitlist_error', { cause: cause });
    } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'upart_waitlist_error', { event_category: 'U-Part', event_label: cause }); } catch (e) {}
  }

  /* ---------- Appels Klaviyo ----------
     Chaque fonction rend une promesse : résolue si Klaviyo a accepté, rejetée avec
     { cause, emailInvalide } sinon. */
  function appelPrincipal(config, chemin, corps) {
    return fetch('https://a.klaviyo.com/client/' + chemin + '?company_id=' + encodeURIComponent(config.klaviyoCle), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION_KLAVIYO },
      body: JSON.stringify(corps)
    }).then(function (res) {
      if (res.ok) return 'principale';
      return res.text().then(function (t) {
        throw { cause: 'klaviyo_' + res.status, emailInvalide: res.status === 400 && /email/i.test(t || '') };
      });
    }, function () {
      throw { cause: 'klaviyo_injoignable', injoignable: true };
    });
  }
  /* Second point d'entrée de Klaviyo (formulaires intégrés), sur un autre domaine : il inscrit
     à la même liste et met à jour les mêmes propriétés. Utilisé seulement si le premier est
     injoignable ou en panne, jamais quand Klaviyo a refusé l'adresse. */
  function appelSecours(config, email, prenom, proprietes) {
    var champs = new URLSearchParams();
    champs.set('g', config.klaviyoListe);
    champs.set('email', email);
    if (prenom) champs.set('$first_name', prenom);
    var noms = ['$source'];
    champs.set('$source', config.source || 'Landing page U-Part');
    Object.keys(proprietes).forEach(function (k) { champs.set(k, String(proprietes[k])); noms.push(k); });
    champs.set('$fields', noms.join(','));
    return fetch(URL_SECOURS, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
      body: champs.toString()
    }).then(function (res) {
      return res.json().then(function (j) {
        if (res.ok && j && j.success === true) return 'secours';
        throw { cause: 'secours_refus', emailInvalide: /email/i.test(JSON.stringify((j && j.errors) || '')) };
      }, function () { throw { cause: 'secours_' + res.status }; });
    }, function () {
      throw { cause: 'tout_injoignable' };
    });
  }
  function avecSecours(principal, secours) {
    return principal().catch(function (e) {
      /* Adresse refusée par Klaviyo : inutile d'insister, c'est l'adresse qu'il faut corriger. */
      if (e && e.emailInvalide) throw e;
      return secours();
    });
  }

  /* ---------- Formulaire ---------- */
  function initFormulaire(racine) {
    var form = racine.querySelector('[data-hmu-form]');
    var merci = racine.querySelector('[data-hmu-merci]');
    if (!form || !merci || form.__hmu) return;
    form.__hmu = true;

    var config = {};
    try { config = JSON.parse(racine.querySelector('[data-hmu-config]').textContent) || {}; } catch (e) {}
    var champEmail = form.querySelector('input[name="email"]');
    var champPrenom = form.querySelector('input[name="prenom"]');
    var bouton = form.querySelector('[type="submit"]');
    var erreur = form.querySelector('[data-hmu-erreur]');
    var consentement = racine.querySelector('[data-hmu-consentement]');
    var libelle = bouton.textContent;
    var provenance = lireProvenance();
    var messageGeneral = config.erreurGenerale || "L'inscription n'a pas pu être enregistrée. Réessaie dans un instant.";
    var messageEmail = config.erreurEmail || 'Indique une adresse e-mail valide.';

    function afficherErreur(message) {
      erreur.textContent = message;
      erreur.hidden = !message;
    }

    champEmail.addEventListener('input', function () {
      champEmail.removeAttribute('aria-invalid');
      afficherErreur('');
    });

    /* Temps 2 — questions facultatives, posées après l'inscription. Chaque choix est
       enregistré aussitôt sur le profil Klaviyo de l'adresse qui vient de s'inscrire. */
    var emailInscrit = '';
    var note = merci.querySelector('[data-hmu-note]');
    merci.querySelectorAll('[data-hmu-question]').forEach(function (question) {
      var propriete = question.getAttribute('data-hmu-question');
      question.addEventListener('change', function (evt) {
        if (!emailInscrit || !evt.target || evt.target.type !== 'radio') return;
        var proprietes = {};
        proprietes[propriete] = evt.target.value;
        avecSecours(function () {
          return appelPrincipal(config, 'profiles', { data: { type: 'profile', attributes: { email: emailInscrit, properties: proprietes } } });
        }, function () {
          return appelSecours(config, emailInscrit, '', proprietes);
        }).then(function () {
          if (note) { note.textContent = config.reponseNotee || "C'est noté 🤍"; note.classList.remove('hmu__note--erreur'); note.hidden = false; }
        }).catch(function (e) {
          console.warn('[hm-upart] Réponse non enregistrée :', e);
          evt.target.checked = false;
          if (note) { note.textContent = config.reponseErreur || 'Réponse non enregistrée. Réessaie.'; note.classList.add('hmu__note--erreur'); note.hidden = false; }
        });
      });
    });

    /* Compteur : la visiteuse qui vient de s'inscrire s'ajoute au nombre affiché. */
    function incrementerCompteur() {
      var compteur = racine.querySelector('[data-hmu-compteur]');
      if (!compteur || compteur.__fait) return;
      var base = parseInt(compteur.getAttribute('data-base'), 10);
      if (!(base > 0)) return;
      compteur.__fait = true;
      compteur.textContent = String(base + 1);
    }

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (form.__envoi) return;
      afficherErreur('');

      var email = (champEmail.value || '').trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        champEmail.setAttribute('aria-invalid', 'true');
        afficherErreur(messageEmail);
        champEmail.focus();
        return;
      }
      if (!config.klaviyoCle || !config.klaviyoListe) {
        afficherErreur(messageGeneral);
        suivreErreur('liste_non_renseignee');
        console.warn('[hm-upart] Identifiant de liste Klaviyo manquant dans les réglages de la section : aucune inscription envoyée.');
        return;
      }

      var proprietes = {
        UPART_WAITLIST: true,
        UPART_WAITLIST_DATE: new Date().toISOString(),
        UPART_WAITLIST_SOURCE: provenance.utm_source || 'direct'
      };
      if (provenance.utm_medium) proprietes.UPART_WAITLIST_MEDIUM = provenance.utm_medium;
      if (provenance.utm_campaign) proprietes.UPART_WAITLIST_CAMPAIGN = provenance.utm_campaign;
      if (provenance.utm_content) proprietes.UPART_WAITLIST_CONTENT = provenance.utm_content;

      var profil = { email: email, properties: proprietes };
      var prenom = (champPrenom && champPrenom.value || '').trim().slice(0, 60);
      if (prenom) profil.first_name = prenom;

      form.__envoi = true;
      bouton.disabled = true;
      bouton.textContent = config.libelleEnvoi || 'Un instant…';

      avecSecours(function () {
        return appelPrincipal(config, 'subscriptions', {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: config.source || 'Landing page U-Part',
              profile: { data: { type: 'profile', attributes: profil } }
            },
            relationships: { list: { data: { type: 'list', id: config.klaviyoListe } } }
          }
        });
      }, function () {
        return appelSecours(config, email, prenom, proprietes);
      }).then(function (voie) {
        /* Klaviyo a accepté l'inscription : confirmation, puis conversions (une fois par adresse). */
        var nouvelle = dejaComptees().indexOf(empreinte(email)) === -1;
        memoriser(email);
        emailInscrit = email;
        if (nouvelle) incrementerCompteur();
        form.hidden = true;
        if (consentement) consentement.hidden = true;
        merci.hidden = false;
        try { merci.focus({ preventScroll: true }); } catch (e) {}
        if (nouvelle) {
          suivreConversion(provenance);
          /* Événement Klaviyo par provenance : sans importance s'il ne part pas. */
          appelPrincipal(config, 'events', {
            data: {
              type: 'event',
              attributes: {
                properties: {
                  source: provenance.utm_source || 'direct',
                  medium: provenance.utm_medium || '',
                  campaign: provenance.utm_campaign || '',
                  content: provenance.utm_content || '',
                  voie: voie,
                  page: window.location.pathname
                },
                metric: { data: { type: 'metric', attributes: { name: 'Inscription liste U-Part' } } },
                profile: { data: { type: 'profile', attributes: { email: email } } }
              }
            }
          }).catch(function () {});
        }
      }).catch(function (e) {
        console.warn('[hm-upart] Inscription Klaviyo refusée ou impossible :', e);
        var invalide = !!(e && e.emailInvalide);
        if (invalide) champEmail.setAttribute('aria-invalid', 'true');
        afficherErreur(invalide ? messageEmail : messageGeneral);
        suivreErreur(invalide ? 'email_refuse' : ((e && e.cause) || 'inconnue'));
      }).then(function () {
        form.__envoi = false;
        bouton.disabled = false;
        bouton.textContent = libelle;
      });
    });
  }

  function init() {
    initMasquageChat();
    document.querySelectorAll('[data-hmu-waitlist]').forEach(initFormulaire);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* Éditeur de thème : une section rechargée retrouve son formulaire. */
  document.addEventListener('shopify:section:load', function (e) {
    var racine = e.target.querySelector && e.target.querySelector('[data-hmu-waitlist]');
    if (racine) initFormulaire(racine);
  });
})();
